// extracted by mini-css-extract-plugin
module.exports = {"root":"Auth_root_3mYhl"};